import { render, staticRenderFns } from "./Project_engineering.vue?vue&type=template&id=49683149&scoped=true&"
import script from "./Project_engineering.vue?vue&type=script&lang=js&"
export * from "./Project_engineering.vue?vue&type=script&lang=js&"
import style0 from "./Project_engineering.vue?vue&type=style&index=0&id=49683149&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49683149",
  null
  
)

export default component.exports